// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1hOYs","approved":"Status_approved__KXcz4","rejected":"Status_rejected__2FkFL","expired":"Status_expired__189K5","label":"Status_label__2jHBY"};